export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20with%20soft%20geometric%20shapes%20in%20coral%20and%20amber%20tones%20elegant%20modern%20design%20subtle%20texture%20editorial%20atmosphere%20clean%20minimal%20composition%20with%20negative%20space&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs md:text-sm font-medium bg-accent-500/90 text-background-50 rounded-full mb-4">
              娱乐圈最新爆料速递
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              爆瓜网 — 娱乐圈最新爆料
              <br className="hidden md:block" />
              速递一站式平台
            </h1>

            <p className="text-base md:text-lg text-white/80 font-heading mb-5">
              每日更新 · 深度追踪 · 百万瓜友在线
            </p>

            <div className="mb-6">
              <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-lg mx-auto lg:mx-0">
                爆瓜网是专业的娱乐资讯聚合平台，覆盖明星动态、影视八卦、综艺热点和娱乐圈爆料。我们拥有7×24小时全天候更新机制，重大爆料5分钟内上线，比你常刷的热搜更快一步。无论是最新电影资讯、热门综艺剧透，还是明星街拍穿搭和深度行业分析，这里都是你一站式获取娱乐圈全部动态的首选入口。当前暑期档激战正酣，多部大片上演票房厮杀，综艺新季接连开播——这是吃瓜最好的季节。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <i className="ri-flashlight-line text-accent-400"></i>
                <span>日均更新 <strong className="text-white">200+</strong> 条</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <i className="ri-group-line text-accent-400"></i>
                <span>月活瓜友 <strong className="text-white">580万</strong></span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <i className="ri-shield-check-line text-accent-400"></i>
                <span>信源 <strong className="text-white">交叉验证</strong> 机制</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                开始吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white border border-white/25 font-medium text-sm rounded-full hover:bg-white/25 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                下载APP
                <i className="ri-download-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20collage%20style%20composition%20warm%20lighting%20celebrity%20events%20movie%20scenes%20music%20stages%20variety%20shows%20dynamic%20colorful%20energetic%20atmosphere%20editorial%20design%20with%20headline%20text%20overlay%20modern%20magazine%20layout&width=1040&height=780&seq=hero-visual&orientation=portrait"
                alt="爆瓜网娱乐资讯聚合主视觉"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-full">
                  今日最热
                </span>
                <p className="text-white/90 text-sm mt-2 font-medium">
                  某顶流深夜现身三里屯，神秘女子引全网猜测
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}